// extracted by mini-css-extract-plugin
export default {"mobileWidth":"980px","desktopWidth":"1520px","root":"navbar_root__N+-WD","wrapper":"navbar_wrapper__OfjoC","link":"navbar_link__S3w3X","linkContent":"navbar_linkContent__mptht"};